/* Static functions */

function confirmDelete(deleteUrl, deletionWarning, loaderText) {
  var r=confirm(deletionWarning);
  if (r==true) {
    
    //showLoader if requested
    if (loaderText != "") {
    showLoader(loaderText);
    }
    
    //call deleten action
    location.href = deleteUrl;
    }
}